import React from 'react';

import { useTheme } from '@mui/material/styles';
import { Button, Grid, Typography } from '@mui/material';

import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

import { useCallService } from 'hooks';

import { ITicketTypeFormInputs } from 'features/ticketTypes/forms/TicketTypeForm';

import httpRoutes from 'utils/httpRoutes';

type DeleteTicketTypeProps = {
  ticketId: number;
  ticket: ITicketTypeFormInputs;
  onSuccess: () => void;
  hideDialog: () => void;
};

const DeleteTicketType = ({
  ticketId,
  ticket,
  onSuccess,
  hideDialog,
}: DeleteTicketTypeProps) => {
  const { callService } = useCallService();

  const theme = useTheme();

  const deleteTicketType = async () => {
    const { response } = await callService({
      resource: httpRoutes.ticketTypes.deleteTicketType(ticketId),
    });

    if (response) {
      onSuccess();
      hideDialog();
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container justifyContent="center">
          <WarningAmberOutlinedIcon
            sx={{ fontSize: '160px', color: theme.palette.warning.dark }}
          />
          <Typography fontSize={24} fontWeight="bold">
            {ticket.name}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} mt={1}>
        <Typography variant="body1" align="center">
          Are you sure you want to delete this ticket type?
        </Typography>
      </Grid>
      <Grid item xs={12} mt={3}>
        <Grid container justifyContent="space-between">
          <Button variant="text" onClick={hideDialog}>
            Cancel
          </Button>

          <Button variant="contained" color="error" onClick={deleteTicketType}>
            Yes, Delete
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DeleteTicketType;
